import React from 'react';

import { Icon } from '../icons';

export const ArrowLeftIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path d="M9.19719 14.5502L8.40442 15.3429C8.06874 15.6786 7.52595 15.6786 7.19384 15.3429L0.251758 8.40442C-0.0839192 8.06874 -0.0839192 7.52595 0.251758 7.19384L7.19384 0.251758C7.52952 -0.0839192 8.07231 -0.0839192 8.40442 0.251758L9.19719 1.04453C9.53644 1.38377 9.52929 1.93728 9.1829 2.26939L4.87981 6.36893H15.143C15.6179 6.36893 16 6.75103 16 7.22598V8.36871C16 8.84366 15.6179 9.22576 15.143 9.22576H4.87981L9.1829 13.3253C9.53286 13.6574 9.54001 14.2109 9.19719 14.5502Z" />
    </svg>
  );
};
